import { Check } from 'lucide-react';

type Props = {
  status: string;
  hasUnsignedContracts?: boolean;
  scriptApproved?: boolean;
  hasSubmission?: boolean;
  compact?: boolean;
};

export default function InvitationNextSteps({
  status,
  hasUnsignedContracts = false,
  scriptApproved = false,
  hasSubmission = false,
  compact = false,
}: Props) {
  const accepted = status === 'ACCEPTED';
  const steps = [
    { label: 'Review brief', done: true },
    {
      label: hasUnsignedContracts && !accepted ? 'Sign contract, then accept' : 'Sign & accept',
      done: accepted,
    },
    { label: 'Approve script', done: scriptApproved },
    { label: 'Submit content', done: hasSubmission },
  ];

  if (compact) {
    return (
      <p className="text-xs text-glass-text-2 mt-3">
        After you accept: sign any contract, approve the script, then submit content.
      </p>
    );
  }

  return (
    <div className="rounded-xl border border-glass bg-glass-2 p-4">
      <p className="text-sm font-medium text-glass-text mb-3">What happens next</p>
      <ol className="space-y-2">
        {steps.map((step, i) => (
          <li key={step.label} className="flex items-center gap-2 text-sm">
            <span
              className={`inline-flex h-5 w-5 items-center justify-center rounded-full text-[0.65rem] font-semibold ${
                step.done
                  ? 'bg-emerald-500/20 text-emerald-600 dark:text-emerald-300'
                  : 'bg-glass-3 text-glass-text-3'
              }`}
            >
              {step.done ? <Check className="h-3 w-3" /> : i + 1}
            </span>
            <span className={step.done ? 'text-glass-text-2 line-through' : 'text-glass-text'}>
              {step.label}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
